import { get, req, post } from '@/plugins/axios'

/**
* 会员规则变更通知弹窗的实现 15天内
* @param {Object} data
*/
export function getMemberRemind (data:any) {
  return post('/settlement/wallet/recharge/membership/remind', data)
}
// 关闭会员变更弹窗
export function getMemberRemindRead (data:any) {
  return post('/settlement/wallet/recharge/membership/remind/readed', data)
}

/**
* 等级变更弹窗
* @param {Object} data
*/
export function memberChangeFlag () {
  return get('/customer/memberChangeFlag')
}
// 关闭等级变更弹窗
export function UpmemberChangeFlag () {
  return get('/customer/update/memberChangeFlag')
}

/**
* API店铺授权变更
* @param {Object} data
*/
export function memberChangeZeroFlag () {
  return get('/customer/memberChangeZeroFlag')
}
// 关闭API店铺授权变更弹窗
export function UpmemberChangeZeroFlag () {
  return get('/customer/update/memberChangeZeroFlag')
}
// 首页展示活动中的会员试用活动/判断当前用户是否有参加活动的权利
export function trialEffective () {
  return get('/settlement/membership/configure/template/select/trial/effective')
}

// 广告埋点 查询
export function membershipIsFirst () {
  return post('/settlement/wallet/recharge/membership/isFirst')
}
